import SoundCache from '../SoundCache';
import Widget from './Widget';

export default class MessageWidget extends Widget {
	constructor({ container, soundManager, voiceApi, mmlApi, baseUrl }) {
		super({ container });
		this.soundManager = soundManager;
		this.voiceApi = voiceApi;
		this.mmlApi = mmlApi;
		this.baseUrl = baseUrl;
		this.soundCache = new SoundCache();
		this._intentionalSuspend = false;
		this._onAudioCtxStateChange = () => this._updateAudioAlert();
	}

	applySettings(settings) {
		super.applySettings(settings);
		this.soundManager.setVolume(Math.min(1, (this.settings.volume ?? 100) / 100));
		this._updateAudioAlert();
	}

	// Subclasses override to indicate whether any audio feature is active.
	_audioRequired() { return true; }

	_createAudioAlert() {
		if(this.audioResumeAlert) return;

		const parent = this.container.parentNode || document.body;
		this.audioResumeAlert = parent.querySelector('.audio-resume-alert');

		if(this.audioResumeAlert) return;

		this.audioResumeAlert = document.createElement('div');
		this.audioResumeAlert.className = 'audio-resume-alert';
		this.audioResumeAlert.textContent = 'Click anywhere to enable audio';
		this.audioResumeAlert.hidden = true;

		parent.insertBefore(this.audioResumeAlert, this.container);
	}

	_updateAudioAlert() {
		if(!this.audioResumeAlert) return;
		this.audioResumeAlert.hidden = !this._audioRequired() || this._intentionalSuspend || this.soundManager.audioCtx.state !== 'suspended';
	}

	_setupAudioMonitor() {
		this.soundManager.audioCtx.addEventListener('statechange', this._onAudioCtxStateChange);
		this._updateAudioAlert();
	}

	destroy() {
		this.soundManager.audioCtx.removeEventListener('statechange', this._onAudioCtxStateChange);
		super.destroy();
		this.soundCache.destroy();
	}
}
